import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Breadcrumb from './Breadcrumb';

function PageShell({
  title,
  subtitle,
  breadcrumbs = [],
  backTo,
  actions,
  children,
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleBack = () => {
    if (location.key && location.key !== 'default') {
      navigate(-1);
      return;
    }

    if (backTo) {
      navigate(backTo);
    }
  };

  return (
    <div className="hr-page-shell">
      <div className="hr-page-shell-top">
        <div className="hr-page-shell-heading">
          {backTo && (
            <button type="button" className="hr-back-btn" onClick={handleBack} aria-label="Go back">
              ← Back
            </button>
          )}
          <div>
            <Breadcrumb items={breadcrumbs} />
            {title && <h2 className="hr-page-shell-title">{title}</h2>}
            {subtitle && <p className="hr-page-shell-subtitle">{subtitle}</p>}
          </div>
        </div>
        {actions && <div className="hr-page-shell-actions">{actions}</div>}
      </div>
      <div className="hr-page-shell-body">{children}</div>
    </div>
  );
}

export default PageShell;
